// extracted by mini-css-extract-plugin
export default {"box":"YearSelector_box__VJCbg"};